// // // ajay:code 19-08-26
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import { ArrowLeft, Save, Lock, Plus, X } from "lucide-react";
// import { productAPI, pfmeaAPI } from "../../services/api";
// import ProcessStepBlock from "../../components/pfmea/ProcessStepBlock";
// import PfmeaSheetView from "../../components/pfmea/PfmeaSheetView";

// const emptyProcessStep = () => ({ step_name: "", requirements: [] });

// // sheetView: only the client route passes this — renders the read-only
// // tree as a real merged-cell grid (matches the source Excel) on desktop.
// // Fill/edit mode (company side) always keeps the card layout — typing into
// // a 19-column table is worse UX than typing into cards.
// export default function PfmeaForm({
//   basePath = "/company/pfmea",
//   sheetView = false,
// }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { id } = useParams();

//   const isEditRoute = location.pathname.endsWith("/edit");
//   const isAddMode = !id;
//   const isLoadExisting = Boolean(id);

//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth < 768 : false,
//   );
//   useEffect(() => {
//     const onResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const [products, setProducts] = useState([]);
//   const [productId, setProductId] = useState("");
//   const [status, setStatus] = useState("Draft");

//   const [header, setHeader] = useState({
//     item_name: "",
//     model: "",
//     process_responsibility: "",
//     fmea_no: "",
//     key_date: "",
//     fmea_date: "",
//     rev_no: "",
//     rev_date: "",
//     rev_description: "",
//   });
//   const [coreTeam, setCoreTeam] = useState([]);
//   const [processSteps, setProcessSteps] = useState([]);
//   const [footer, setFooter] = useState({
//     prepared_by: "",
//     approved_by: "",
//     control_status: "",
//   });

//   const [loading, setLoading] = useState(isLoadExisting);
//   const [saving, setSaving] = useState(false);
//   const [err, setErr] = useState("");

//   const isReadOnly = isLoadExisting && (!isEditRoute || status === "Final");

//   useEffect(() => {
//     if (isLoadExisting) return;
//     productAPI.list().then((r) => {
//       const active = (r.data || []).filter((p) => p.status === "Active");
//       setProducts(active);
//     });
//   }, [isLoadExisting]);

//   useEffect(() => {
//     if (!isLoadExisting) return;
//     setLoading(true);
//     pfmeaAPI
//       .getDocument(id)
//       .then((r) => {
//         const doc = r.data;
//         setStatus(doc.status);
//         setProductId(String(doc.product_id));
//         setProducts([
//           {
//             id: doc.product_id,
//             name: doc.Product?.name,
//             code: doc.Product?.code,
//           },
//         ]);
//         setHeader({
//           item_name: doc.item_name || "",
//           model: doc.model || "",
//           process_responsibility: doc.process_responsibility || "",
//           fmea_no: doc.fmea_no || "",
//           key_date: doc.key_date || "",
//           fmea_date: doc.fmea_date || "",
//           rev_no: doc.rev_no || "",
//           rev_date: doc.rev_date || "",
//           rev_description: doc.rev_description || "",
//         });
//         setCoreTeam((doc.coreTeam || []).map((m) => m.member_name));
//         setFooter({
//           prepared_by: doc.prepared_by || "",
//           approved_by: doc.approved_by || "",
//           control_status: doc.control_status || "",
//         });
//         setProcessSteps(
//           (doc.processSteps || []).map((s) => ({
//             step_name: s.step_name,
//             requirements: (s.requirements || []).map((r) => ({
//               requirement_text: r.requirement_text,
//               failure_modes: (r.failureModes || []).map((f) => ({
//                 failure_mode_text: f.failure_mode_text,
//                 severity: f.severity ?? "",
//                 class: f.class || "",
//                 effects: f.effects || [],
//                 causes: (f.causes || []).map((c) => ({
//                   cause_text: c.cause_text,
//                   occurrence: c.occurrence ?? "",
//                   control_prevention: c.control_prevention || [],
//                   control_detection: c.control_detection || [],
//                   detection: c.detection ?? "",
//                   recommended_action: c.recommended_action || "",
//                   responsibility: c.responsibility || "",
//                   target_date: c.target_date || "",
//                   action_taken: c.action_taken || [],
//                   revised_severity: c.revised_severity ?? "",
//                   revised_occurrence: c.revised_occurrence ?? "",
//                   revised_detection: c.revised_detection ?? "",
//                 })),
//               })),
//             })),
//           })),
//         );
//       })
//       .catch((e) => setErr(e.message))
//       .finally(() => setLoading(false));
//   }, [id, isLoadExisting]);

//   const updateProcessStep = (i, updated) => {
//     setProcessSteps((prev) => prev.map((s, idx) => (idx === i ? updated : s)));
//   };
//   const addProcessStep = () =>
//     setProcessSteps((prev) => [...prev, emptyProcessStep()]);
//   const removeProcessStep = (i) =>
//     setProcessSteps((prev) => prev.filter((_, idx) => idx !== i));

//   const addTeamMember = () => setCoreTeam((prev) => [...prev, ""]);
//   const updateTeamMember = (i, value) =>
//     setCoreTeam((prev) => prev.map((m, idx) => (idx === i ? value : m)));
//   const removeTeamMember = (i) =>
//     setCoreTeam((prev) => prev.filter((_, idx) => idx !== i));

//   const submit = async () => {
//     setErr("");
//     if (!productId) return setErr("Select a part");
//     if (processSteps.length === 0)
//       return setErr("Add at least one process step");

//     setSaving(true);
//     try {
//       const payload = {
//         ...header,
//         ...footer,
//         core_team: coreTeam.filter((m) => m.trim()),
//         process_steps: processSteps,
//       };
//       if (isEditRoute) {
//         await pfmeaAPI.updateDocument(id, payload);
//       } else {
//         await pfmeaAPI.createDocument({ product_id: productId, ...payload });
//       }
//       navigate(basePath);
//     } catch (e) {
//       setErr(e.message || "Failed to submit");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const finalize = async () => {
//     if (
//       !window.confirm(
//         "Finalize this PFMEA document? Once finalized it can NEVER be edited again, by anyone.",
//       )
//     )
//       return;
//     setSaving(true);
//     try {
//       await pfmeaAPI.finalizeDocument(id);
//       setStatus("Final");
//     } catch (e) {
//       setErr(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const selectedProduct = products.find(
//     (p) => String(p.id) === String(productId),
//   );

//   if (loading)
//     return <div style={{ padding: 28, color: "var(--text2)" }}>Loading...</div>;

//   const inputStyle = {
//     width: "100%",
//     padding: "6px 10px",
//     fontSize: 12,
//     borderRadius: 6,
//     border: "1px solid var(--border2)",
//     background: "var(--surface2)",
//     color: "var(--text)",
//   };
//   const labelStyle = {
//     fontSize: 10,
//     color: "var(--text3)",
//     fontWeight: 700,
//     marginBottom: 3,
//     display: "block",
//   };

//   return (
//     <div style={{ padding: 28, maxWidth: 1100, margin: "0 auto" }}>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 12,
//           marginBottom: 20,
//           flexWrap: "wrap",
//         }}
//       >
//         <button onClick={() => navigate(basePath)} style={iconBtn}>
//           <ArrowLeft size={16} />
//         </button>
//         <div style={{ flex: 1 }}>
//           <h1 style={{ fontSize: 20, fontWeight: 700 }}>
//             {isAddMode
//               ? "Add PFMEA"
//               : isReadOnly
//                 ? "PFMEA Document (View)"
//                 : "Edit PFMEA Document"}
//           </h1>
//           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//             Potential Failure Mode & Effect Analysis (Process FMEA)
//           </p>
//         </div>
//         {isLoadExisting && (
//           <span
//             className={`badge ${status === "Final" ? "badge-success" : "badge-danger"}`}
//             style={{ display: "flex", alignItems: "center", gap: 4 }}
//           >
//             {status === "Final" && <Lock size={11} />} {status}
//           </span>
//         )}
//         {isLoadExisting && status === "Draft" && !isEditRoute && (
//           <button
//             className="btn-secondary"
//             onClick={() => navigate(`${basePath}/${id}/edit`)}
//           >
//             Edit
//           </button>
//         )}
//         {isLoadExisting && status === "Draft" && (
//           <button
//             className="btn-primary"
//             onClick={finalize}
//             disabled={saving}
//             style={{
//               background: "var(--danger)",
//               borderColor: "var(--danger)",
//             }}
//           >
//             Finalize (Lock)
//           </button>
//         )}
//       </div>

//       {err && (
//         <div
//           className="card"
//           style={{ color: "var(--danger)", marginBottom: 16 }}
//         >
//           {err}
//         </div>
//       )}
//       {isLoadExisting && status === "Final" && (
//         <div
//           className="card"
//           style={{
//             marginBottom: 16,
//             color: "var(--text2)",
//             fontSize: 12,
//             display: "flex",
//             alignItems: "center",
//             gap: 8,
//           }}
//         >
//           <Lock size={13} /> This document is Final and locked — no further
//           edits are possible.
//         </div>
//       )}

//       {/* ── Header ── */}
//       <div className="card" style={{ marginBottom: 20 }}>
//         <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
//           Header
//         </h3>
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
//             gap: 12,
//           }}
//         >
//           <div>
//             <label style={labelStyle}>Part No.</label>
//             {!isAddMode ? (
//               <input
//                 type="text"
//                 disabled
//                 style={inputStyle}
//                 value={`${selectedProduct?.name || ""} (${selectedProduct?.code || ""})`}
//               />
//             ) : (
//               <select
//                 value={productId}
//                 onChange={(e) => setProductId(e.target.value)}
//                 style={inputStyle}
//               >
//                 <option value="">— Select part —</option>
//                 {products.map((p) => (
//                   <option key={p.id} value={p.id}>
//                     {p.name} ({p.code})
//                   </option>
//                 ))}
//               </select>
//             )}
//           </div>
//           {[
//             ["item_name", "Item"],
//             ["model", "Model"],
//             ["process_responsibility", "Process Responsibility"],
//             ["fmea_no", "FMEA No."],
//           ].map(([field, label]) => (
//             <div key={field}>
//               <label style={labelStyle}>{label}</label>
//               <input
//                 type="text"
//                 disabled={isReadOnly}
//                 style={inputStyle}
//                 value={header[field]}
//                 onChange={(e) =>
//                   setHeader({ ...header, [field]: e.target.value })
//                 }
//               />
//             </div>
//           ))}
//           {[
//             ["key_date", "Key Date"],
//             ["fmea_date", "FMEA Date"],
//             ["rev_no", "Rev No."],
//             ["rev_date", "Rev Date"],
//           ].map(([field, label]) => (
//             <div key={field}>
//               <label style={labelStyle}>{label}</label>
//               <input
//                 type={field.includes("date") ? "date" : "text"}
//                 disabled={isReadOnly}
//                 style={inputStyle}
//                 value={header[field]}
//                 onChange={(e) =>
//                   setHeader({ ...header, [field]: e.target.value })
//                 }
//               />
//             </div>
//           ))}
//         </div>
//         <div style={{ marginTop: 12 }}>
//           <label style={labelStyle}>Rev Description</label>
//           <textarea
//             rows={2}
//             disabled={isReadOnly}
//             style={inputStyle}
//             value={header.rev_description}
//             onChange={(e) =>
//               setHeader({ ...header, rev_description: e.target.value })
//             }
//           />
//         </div>
//       </div>

//       {/* ── Core Team ── */}
//       <div className="card" style={{ marginBottom: 20 }}>
//         <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
//           Core Team
//         </h3>
//         {coreTeam.map((m, i) => (
//           <div
//             key={i}
//             style={{
//               display: "flex",
//               gap: 8,
//               marginBottom: 6,
//               alignItems: "center",
//             }}
//           >
//             {readOnlyLine(
//               isReadOnly,
//               m,
//               (v) => updateTeamMember(i, v),
//               () => removeTeamMember(i),
//             )}
//           </div>
//         ))}
//         {coreTeam.length === 0 && isReadOnly && (
//           <div style={{ fontSize: 12, color: "var(--text3)" }}>—</div>
//         )}
//         {!isReadOnly && (
//           <button type="button" onClick={addTeamMember} style={addBtnStyle}>
//             <Plus size={12} /> Add Member
//           </button>
//         )}
//       </div>

//       {/* ── Process Steps (nested tree) ── */}
//       <div style={{ marginBottom: 20 }}>
//         <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
//           Process Steps ({processSteps.length})
//         </h3>
//         {isReadOnly && sheetView && !isMobile ? (
//           <PfmeaSheetView processSteps={processSteps} />
//         ) : (
//           <>
//             {processSteps.map((s, i) => (
//               <ProcessStepBlock
//                 key={i}
//                 step={s}
//                 index={i}
//                 onChange={(updated) => updateProcessStep(i, updated)}
//                 onDelete={() => removeProcessStep(i)}
//                 readOnly={isReadOnly}
//               />
//             ))}
//             {processSteps.length === 0 && (
//               <div
//                 className="card"
//                 style={{
//                   textAlign: "center",
//                   color: "var(--text3)",
//                   padding: 20,
//                 }}
//               >
//                 {isReadOnly
//                   ? "No process steps"
//                   : "Add your first process step below"}
//               </div>
//             )}
//           </>
//         )}
//         {!isReadOnly && (
//           <button
//             type="button"
//             onClick={addProcessStep}
//             style={{ ...addBtnStyle, padding: "8px 16px", fontSize: 13 }}
//           >
//             <Plus size={14} /> Add Process Step
//           </button>
//         )}
//       </div>

//       {/* ── Footer ── */}
//       <div className="card" style={{ marginBottom: 20 }}>
//         <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
//           Sign-off
//         </h3>
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr 1fr",
//             gap: 12,
//           }}
//         >
//           <div>
//             <label style={labelStyle}>Prepared By</label>
//             <input
//               type="text"
//               disabled={isReadOnly}
//               style={inputStyle}
//               value={footer.prepared_by}
//               onChange={(e) =>
//                 setFooter({ ...footer, prepared_by: e.target.value })
//               }
//             />
//           </div>
//           <div>
//             <label style={labelStyle}>Approved By</label>
//             <input
//               type="text"
//               disabled={isReadOnly}
//               style={inputStyle}
//               value={footer.approved_by}
//               onChange={(e) =>
//                 setFooter({ ...footer, approved_by: e.target.value })
//               }
//             />
//           </div>
//           <div>
//             <label style={labelStyle}>Control Status</label>
//             <input
//               type="text"
//               disabled={isReadOnly}
//               style={inputStyle}
//               value={footer.control_status}
//               onChange={(e) =>
//                 setFooter({ ...footer, control_status: e.target.value })
//               }
//             />
//           </div>
//         </div>
//       </div>

//       {!isReadOnly && (
//         <button
//           className="btn-primary"
//           onClick={submit}
//           disabled={saving}
//           style={{ display: "flex", alignItems: "center", gap: 8 }}
//         >
//           <Save size={15} />{" "}
//           {saving ? "Saving..." : isEditRoute ? "Save Changes" : "Submit PFMEA"}
//         </button>
//       )}
//     </div>
//   );
// }

// function readOnlyLine(readOnly, value, onChange, onDelete) {
//   if (readOnly) return <div style={{ fontSize: 12 }}>{value || "—"}</div>;
//   return (
//     <>
//       <input
//         type="text"
//         value={value}
//         placeholder="Member name"
//         onChange={(e) => onChange(e.target.value)}
//         style={{
//           flex: 1,
//           padding: "5px 8px",
//           fontSize: 12,
//           borderRadius: 6,
//           border: "1px solid var(--border2)",
//           background: "var(--surface2)",
//           color: "var(--text)",
//         }}
//       />
//       <button
//         type="button"
//         onClick={onDelete}
//         style={{
//           background: "none",
//           border: "none",
//           color: "var(--danger)",
//           cursor: "pointer",
//         }}
//       >
//         <X size={13} />
//       </button>
//     </>
//   );
// }

// const iconBtn = {
//   background: "var(--surface2)",
//   border: "1px solid var(--border)",
//   borderRadius: 6,
//   padding: 6,
//   cursor: "pointer",
//   color: "var(--text2)",
//   display: "flex",
// };

// const addBtnStyle = {
//   display: "flex",
//   alignItems: "center",
//   gap: 4,
//   background: "var(--surface2)",
//   border: "1px solid var(--border2)",
//   borderRadius: 6,
//   padding: "5px 10px",
//   fontSize: 11,
//   fontWeight: 600,
//   color: "var(--accent)",
//   cursor: "pointer",
// };

// // ajay:code 19-08-26
import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ArrowLeft, Save, Lock, Plus, X } from "lucide-react";
import { productAPI, pfmeaAPI } from "../../services/api";
import ProcessStepBlock from "../../components/pfmea/ProcessStepBlock";
import PfmeaSheetView from "../../components/pfmea/PfmeaSheetView";
import PfmeaSheetHeader from "../../components/pfmea/PfmeaSheetHeader";

const emptyProcessStep = () => ({ step_name: "", requirements: [] });

// sheetView: only the client route passes this — renders the read-only
// tree as a real merged-cell grid (matches the source Excel) on desktop.
// Fill/edit mode (company side) always keeps the card layout — typing into
// a 19-column table is worse UX than typing into cards.
export default function PfmeaForm({
  basePath = "/company/pfmea",
  sheetView = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const isEditRoute = location.pathname.endsWith("/edit");
  const isAddMode = !id;
  const isLoadExisting = Boolean(id);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState("");
  const [status, setStatus] = useState("Draft");

  const [header, setHeader] = useState({
    item_name: "",
    model: "",
    process_responsibility: "",
    fmea_no: "",
    key_date: "",
    fmea_date: "",
    rev_no: "",
    rev_date: "",
    rev_description: "",
  });
  const [coreTeam, setCoreTeam] = useState([]);
  const [processSteps, setProcessSteps] = useState([]);
  const [docMeta, setDocMeta] = useState(null); // { Company, Product } — for the Excel-style read-only header
  const [footer, setFooter] = useState({
    prepared_by: "",
    approved_by: "",
    control_status: "",
  });

  const [loading, setLoading] = useState(isLoadExisting);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const isReadOnly = isLoadExisting && (!isEditRoute || status === "Final");

  useEffect(() => {
    if (isLoadExisting) return;
    productAPI.list().then((r) => {
      const active = (r.data || []).filter((p) => p.status === "Active");
      setProducts(active);
    });
  }, [isLoadExisting]);

  useEffect(() => {
    if (!isLoadExisting) return;
    setLoading(true);
    pfmeaAPI
      .getDocument(id)
      .then((r) => {
        const doc = r.data;
        setStatus(doc.status);
        setProductId(String(doc.product_id));
        setDocMeta({
          Company: doc.Company || null,
          Product: doc.Product || null,
        });
        setProducts([
          {
            id: doc.product_id,
            name: doc.Product?.name,
            code: doc.Product?.code,
          },
        ]);
        setHeader({
          item_name: doc.item_name || "",
          model: doc.model || "",
          process_responsibility: doc.process_responsibility || "",
          fmea_no: doc.fmea_no || "",
          key_date: doc.key_date || "",
          fmea_date: doc.fmea_date || "",
          rev_no: doc.rev_no || "",
          rev_date: doc.rev_date || "",
          rev_description: doc.rev_description || "",
        });
        setCoreTeam((doc.coreTeam || []).map((m) => m.member_name));
        setFooter({
          prepared_by: doc.prepared_by || "",
          approved_by: doc.approved_by || "",
          control_status: doc.control_status || "",
        });
        setProcessSteps(
          (doc.processSteps || []).map((s) => ({
            step_name: s.step_name,
            requirements: (s.requirements || []).map((r) => ({
              requirement_text: r.requirement_text,
              failure_modes: (r.failureModes || []).map((f) => ({
                failure_mode_text: f.failure_mode_text,
                severity: f.severity ?? "",
                class: f.class || "",
                effects: f.effects || [],
                causes: (f.causes || []).map((c) => ({
                  cause_text: c.cause_text,
                  occurrence: c.occurrence ?? "",
                  control_prevention: c.control_prevention || [],
                  control_detection: c.control_detection || [],
                  detection: c.detection ?? "",
                  recommended_action: c.recommended_action || "",
                  responsibility: c.responsibility || "",
                  target_date: c.target_date || "",
                  action_taken: c.action_taken || [],
                  revised_severity: c.revised_severity ?? "",
                  revised_occurrence: c.revised_occurrence ?? "",
                  revised_detection: c.revised_detection ?? "",
                })),
              })),
            })),
          })),
        );
      })
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false));
  }, [id, isLoadExisting]);

  const updateProcessStep = (i, updated) => {
    setProcessSteps((prev) => prev.map((s, idx) => (idx === i ? updated : s)));
  };
  const addProcessStep = () =>
    setProcessSteps((prev) => [...prev, emptyProcessStep()]);
  const removeProcessStep = (i) =>
    setProcessSteps((prev) => prev.filter((_, idx) => idx !== i));

  const addTeamMember = () => setCoreTeam((prev) => [...prev, ""]);
  const updateTeamMember = (i, value) =>
    setCoreTeam((prev) => prev.map((m, idx) => (idx === i ? value : m)));
  const removeTeamMember = (i) =>
    setCoreTeam((prev) => prev.filter((_, idx) => idx !== i));

  const submit = async () => {
    setErr("");
    if (!productId) return setErr("Select a part");
    if (processSteps.length === 0)
      return setErr("Add at least one process step");

    setSaving(true);
    try {
      const payload = {
        ...header,
        ...footer,
        core_team: coreTeam.filter((m) => m.trim()),
        process_steps: processSteps,
      };
      if (isEditRoute) {
        await pfmeaAPI.updateDocument(id, payload);
      } else {
        await pfmeaAPI.createDocument({ product_id: productId, ...payload });
      }
      navigate(basePath);
    } catch (e) {
      setErr(e.message || "Failed to submit");
    } finally {
      setSaving(false);
    }
  };

  const finalize = async () => {
    if (
      !window.confirm(
        "Finalize this PFMEA document? Once finalized it can NEVER be edited again, by anyone.",
      )
    )
      return;
    setSaving(true);
    try {
      await pfmeaAPI.finalizeDocument(id);
      setStatus("Final");
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  };

  const selectedProduct = products.find(
    (p) => String(p.id) === String(productId),
  );

  if (loading)
    return <div style={{ padding: 28, color: "var(--text2)" }}>Loading...</div>;

  const inputStyle = {
    width: "100%",
    padding: "6px 10px",
    fontSize: 12,
    borderRadius: 6,
    border: "1px solid var(--border2)",
    background: "var(--surface2)",
    color: "var(--text)",
  };
  const labelStyle = {
    fontSize: 10,
    color: "var(--text3)",
    fontWeight: 700,
    marginBottom: 3,
    display: "block",
  };

  return (
    <div style={{ padding: 28, maxWidth: 1100, margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <button onClick={() => navigate(basePath)} style={iconBtn}>
          <ArrowLeft size={16} />
        </button>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>
            {isAddMode
              ? "Add PFMEA"
              : isReadOnly
                ? "PFMEA Document (View)"
                : "Edit PFMEA Document"}
          </h1>
          <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
            Potential Failure Mode & Effect Analysis (Process FMEA)
          </p>
        </div>
        {isLoadExisting && (
          <span
            className={`badge ${status === "Final" ? "badge-success" : "badge-danger"}`}
            style={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            {status === "Final" && <Lock size={11} />} {status}
          </span>
        )}
        {isLoadExisting && status === "Draft" && !isEditRoute && (
          <button
            className="btn-secondary"
            onClick={() => navigate(`${basePath}/${id}/edit`)}
          >
            Edit
          </button>
        )}
        {isLoadExisting && status === "Draft" && (
          <button
            className="btn-primary"
            onClick={finalize}
            disabled={saving}
            style={{
              background: "var(--danger)",
              borderColor: "var(--danger)",
            }}
          >
            Finalize (Lock)
          </button>
        )}
      </div>

      {err && (
        <div
          className="card"
          style={{ color: "var(--danger)", marginBottom: 16 }}
        >
          {err}
        </div>
      )}
      {isLoadExisting && status === "Final" && (
        <div
          className="card"
          style={{
            marginBottom: 16,
            color: "var(--text2)",
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Lock size={13} /> This document is Final and locked — no further
          edits are possible.
        </div>
      )}

      {isReadOnly ? (
        <PfmeaSheetHeader doc={{ ...header, ...docMeta }} coreTeam={coreTeam} />
      ) : (
        <>
          {/* ── Header ── */}
          <div className="card" style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
              Header
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
                gap: 12,
              }}
            >
              <div>
                <label style={labelStyle}>Part No.</label>
                {!isAddMode ? (
                  <input
                    type="text"
                    disabled
                    style={inputStyle}
                    value={`${selectedProduct?.name || ""} (${selectedProduct?.code || ""})`}
                  />
                ) : (
                  <select
                    value={productId}
                    onChange={(e) => setProductId(e.target.value)}
                    style={inputStyle}
                  >
                    <option value="">— Select part —</option>
                    {products.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name} ({p.code})
                      </option>
                    ))}
                  </select>
                )}
              </div>
              {[
                ["item_name", "Item"],
                ["model", "Model"],
                ["process_responsibility", "Process Responsibility"],
                ["fmea_no", "FMEA No."],
              ].map(([field, label]) => (
                <div key={field}>
                  <label style={labelStyle}>{label}</label>
                  <input
                    type="text"
                    disabled={isReadOnly}
                    style={inputStyle}
                    value={header[field]}
                    onChange={(e) =>
                      setHeader({ ...header, [field]: e.target.value })
                    }
                  />
                </div>
              ))}
              {[
                ["key_date", "Key Date"],
                ["fmea_date", "FMEA Date"],
                ["rev_no", "Rev No."],
                ["rev_date", "Rev Date"],
              ].map(([field, label]) => (
                <div key={field}>
                  <label style={labelStyle}>{label}</label>
                  <input
                    type={field.includes("date") ? "date" : "text"}
                    disabled={isReadOnly}
                    style={inputStyle}
                    value={header[field]}
                    onChange={(e) =>
                      setHeader({ ...header, [field]: e.target.value })
                    }
                  />
                </div>
              ))}
            </div>
            <div style={{ marginTop: 12 }}>
              <label style={labelStyle}>Rev Description</label>
              <textarea
                rows={2}
                disabled={isReadOnly}
                style={inputStyle}
                value={header.rev_description}
                onChange={(e) =>
                  setHeader({ ...header, rev_description: e.target.value })
                }
              />
            </div>
          </div>

          {/* ── Core Team ── */}
          <div className="card" style={{ marginBottom: 20 }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
              Core Team
            </h3>
            {coreTeam.map((m, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 8,
                  marginBottom: 6,
                  alignItems: "center",
                }}
              >
                {readOnlyLine(
                  isReadOnly,
                  m,
                  (v) => updateTeamMember(i, v),
                  () => removeTeamMember(i),
                )}
              </div>
            ))}
            {coreTeam.length === 0 && isReadOnly && (
              <div style={{ fontSize: 12, color: "var(--text3)" }}>—</div>
            )}
            {!isReadOnly && (
              <button type="button" onClick={addTeamMember} style={addBtnStyle}>
                <Plus size={12} /> Add Member
              </button>
            )}
          </div>
        </>
      )}

      {/* ── Process Steps (nested tree) ── */}
      <div style={{ marginBottom: 20 }}>
        <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
          Process Steps ({processSteps.length})
        </h3>
        {isReadOnly && sheetView && !isMobile ? (
          <PfmeaSheetView processSteps={processSteps} />
        ) : (
          <>
            {processSteps.map((s, i) => (
              <ProcessStepBlock
                key={i}
                step={s}
                index={i}
                onChange={(updated) => updateProcessStep(i, updated)}
                onDelete={() => removeProcessStep(i)}
                readOnly={isReadOnly}
              />
            ))}
            {processSteps.length === 0 && (
              <div
                className="card"
                style={{
                  textAlign: "center",
                  color: "var(--text3)",
                  padding: 20,
                }}
              >
                {isReadOnly
                  ? "No process steps"
                  : "Add your first process step below"}
              </div>
            )}
          </>
        )}
        {!isReadOnly && (
          <button
            type="button"
            onClick={addProcessStep}
            style={{ ...addBtnStyle, padding: "8px 16px", fontSize: 13 }}
          >
            <Plus size={14} /> Add Process Step
          </button>
        )}
      </div>

      {/* ── Footer ── */}
      <div className="card" style={{ marginBottom: 20 }}>
        <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
          Sign-off
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 12,
          }}
        >
          <div>
            <label style={labelStyle}>Prepared By</label>
            <input
              type="text"
              disabled={isReadOnly}
              style={inputStyle}
              value={footer.prepared_by}
              onChange={(e) =>
                setFooter({ ...footer, prepared_by: e.target.value })
              }
            />
          </div>
          <div>
            <label style={labelStyle}>Approved By</label>
            <input
              type="text"
              disabled={isReadOnly}
              style={inputStyle}
              value={footer.approved_by}
              onChange={(e) =>
                setFooter({ ...footer, approved_by: e.target.value })
              }
            />
          </div>
          <div>
            <label style={labelStyle}>Control Status</label>
            <input
              type="text"
              disabled={isReadOnly}
              style={inputStyle}
              value={footer.control_status}
              onChange={(e) =>
                setFooter({ ...footer, control_status: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      {!isReadOnly && (
        <button
          className="btn-primary"
          onClick={submit}
          disabled={saving}
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <Save size={15} />{" "}
          {saving ? "Saving..." : isEditRoute ? "Save Changes" : "Submit PFMEA"}
        </button>
      )}
    </div>
  );
}

function readOnlyLine(readOnly, value, onChange, onDelete) {
  if (readOnly) return <div style={{ fontSize: 12 }}>{value || "—"}</div>;
  return (
    <>
      <input
        type="text"
        value={value}
        placeholder="Member name"
        onChange={(e) => onChange(e.target.value)}
        style={{
          flex: 1,
          padding: "5px 8px",
          fontSize: 12,
          borderRadius: 6,
          border: "1px solid var(--border2)",
          background: "var(--surface2)",
          color: "var(--text)",
        }}
      />
      <button
        type="button"
        onClick={onDelete}
        style={{
          background: "none",
          border: "none",
          color: "var(--danger)",
          cursor: "pointer",
        }}
      >
        <X size={13} />
      </button>
    </>
  );
}

const iconBtn = {
  background: "var(--surface2)",
  border: "1px solid var(--border)",
  borderRadius: 6,
  padding: 6,
  cursor: "pointer",
  color: "var(--text2)",
  display: "flex",
};

const addBtnStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
  background: "var(--surface2)",
  border: "1px solid var(--border2)",
  borderRadius: 6,
  padding: "5px 10px",
  fontSize: 11,
  fontWeight: 600,
  color: "var(--accent)",
  cursor: "pointer",
};
